import { globalData } from "../..";
import { DEFAULT_COLORS } from "../../colors";
import { pushToDataLayer, returnUrl } from "../../env";

const chatCta = () => {

    const { ctaFontColor, ctaBackgroundColor } = DEFAULT_COLORS

    const footer = document.createElement("a");
    footer.id = 'chatheadFooter'
    footer.style.color = ctaFontColor;
    returnUrl(footer);
    footer.addEventListener('click', () => {
        pushToDataLayer({
            eventCategory: 'homepage',
            eventLabel: 'chat head bubble'
        })
    })

    const cta = document.createElement("div");
    cta.id = 'chatheadCta'
    cta.style.backgroundColor = ctaBackgroundColor;
    cta.textContent = globalData.ctaText;

    footer.append(cta)

    return footer

}

export default chatCta